module.exports = __webpack_public_path__ + "assets/img/login-logo.f8ec5984.png";